import VueRouter from 'vue-router'
import home from '@/components/home/home'
import model from '@/components/model/model'
import notFound from '@/components/home/not_found_page'
import changelogPage from '@/components/home/changelog_page'
import store from '../store/index'
import _find from 'lodash/find'
import _flatMap from 'lodash/flatMap'
import _get from 'lodash/get'

export const routes = [
  {
    path: '/',
    name: 'home',
    component: home,
    auth: true
  },
  {
    path: '/model/:id',
    name: 'model',
    component: model,
    auth: true
  },
  {
    path: '/not-found',
    name: 'not-found',
    component: notFound,
    auth: true
  },
  {
    path: '*',
    name: 'not-found',
    component: notFound,
    auth: true
  },
  {
    path: '/changelog',
    name: 'changelog',
    component: changelogPage,
    auth: true
  }
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

router.beforeEach(async (to, from, next) => {
  const route = _find(_flatMap(routes, routeItem => routeItem.children
    ? routeItem.children
    : routeItem), { name: to.name })

  if (!route) {
    // redirect to wildcard route in case of routing to unextisting route witout auth checks
    return next()
  }

  try {
    await store.dispatch('auth/checkAuthentication', {
      initialPath: to.path,
      token: _get(to, 'query.token')
    })

    return to.name === 'login' ? next('/') : next()
  } catch (error) {
    if (route.auth || route.path === '*') {
      return store.dispatch('auth/redirectToAuthPage')
    }
    return next()
  }
})

export default router
